import React from "react";
import { motion } from "framer-motion";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-gray-900 text-gray-100 py-10 mt-16"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid gap-8 md:grid-cols-3">
        {/* Branding */}
        <div>
          <h2 className="text-2xl font-bold text-white">Questa</h2>
          <p className="mt-2 text-gray-400">
            Powerful survey solutions made simple. Design. Share. Analyze.
          </p>
        </div>

        {/* Links */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-gray-400">
            <li><a href="#features" className="hover:text-white">Features</a></li>
            <li><a href="#pricing" className="hover:text-white">Pricing</a></li>
            <li><a href="#faq" className="hover:text-white">FAQ</a></li>
            <li><a href="#contact" className="hover:text-white">Contact</a></li>
          </ul>
        </div>

        {/* Socials */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Connect with Us</h3>
          <div className="flex space-x-4">
            <a href="https://facebook.com" aria-label="Facebook" className="hover:text-white">
              <Facebook size={20} />
            </a>
            <a href="https://twitter.com" aria-label="Twitter" className="hover:text-white">
              <Twitter size={20} />
            </a>
            <a href="https://instagram.com" aria-label="Instagram" className="hover:text-white">
              <Instagram size={20} />
            </a>
            <a href="https://linkedin.com" aria-label="LinkedIn" className="hover:text-white">
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="text-center pt-4 text-sm text-gray-400">
        © {new Date().getFullYear()} Questa App . All rights reserved.
        <br />
        <p>Questa is one of many web applications published by MB-Techs</p>
        <span className="text-[#CC5500] font-semibold">Powered by <a href="https://mb-techs.com">MB-Techs LLC</a></span>
      </div>
    </motion.footer>
  );
}
